var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden)?_c('div',{class:['lc-block-progress', { loading: _vm.isLoading }],style:(_vm.style.root)},[_c('div',{style:(_vm.style.innerDiv)},[_c('spinner',{attrs:{"size":56}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }